import { useMutation, useQueryClient } from '@tanstack/react-query';

import { useAccountIdFromQueryParam } from '@/react-query/hooks/query/use-account';
import { orderDebitCard } from '@/react-query/services/order';

import { DeprecatedCardOrderRequest } from '@generated-types';

export const useOrderCard = (accountNumber: string, manual = false) => {
    const queryClient = useQueryClient();
    const accountId = useAccountIdFromQueryParam();
    return useMutation({
        mutationKey: ['orderCard', accountNumber, manual],
        mutationFn: ({ changePin }: DeprecatedCardOrderRequest) => orderDebitCard(accountNumber, changePin, manual),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['myDebitCards'] });
            queryClient.invalidateQueries({ queryKey: ['DebitAccounts'] });
            queryClient.invalidateQueries({ queryKey: ['debitAccount', accountId] });
        },
    });
};
